import { Add, UploadFile } from '@mui/icons-material'
import { Box, Button, Grid, Typography } from '@mui/material'
import React, { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { useAppDispatch, useAppSelector } from '../../../../Redux/store'
import { setNextDisabled } from '../Slices/TalentProfileCreationSlice'
import { KaziAvatar } from '../../../../Shared Components/Kazi/KaziAvatar'

interface IPhotoUploadProps {
    setUploadedFile: (file: File | undefined) => void;
    uploadedFile: File | undefined;
}

export const PhotoUpload = ({setUploadedFile, uploadedFile}: IPhotoUploadProps) => {
    /* ******************** Hooks ******************** */
    const onDrop = useCallback((acceptedFiles: any ) => {
        setUploadedFile(acceptedFiles[0]);
    }, [])
    const {getRootProps, getInputProps, isDragActive, open} = useDropzone({onDrop, accept: {'image/png': ['.png'], 'image/jpg': ['.jpg'],}, maxFiles: 1, maxSize: 10000000});
    /* ******************** Variables ******************** */
    const userType = useAppSelector( state => state.Global.userType);
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    const objectUrl = useMemo(() => { 
        if (uploadedFile) {
            try {
                const object = URL.createObjectURL(uploadedFile);
                return object;
            } catch (err) {
                console.error("Unable to create object from url: ", err);
            }
        }
        return undefined;
    }, [uploadedFile, setUploadedFile])
    // useEffect(() => {
    //     if ((uploadedFile || showInitials) && nextDisabled) {
    //         dispatch(setNextDisabled(false));
    //     }
    //     if ((!uploadedFile&&!showInitials) && !nextDisabled) {
    //         dispatch(setNextDisabled(true));
    //     }
    // }, [uploadedFile, showInitials])
    /* ******************** JSX ******************** */
    return (
        <Grid container>
            <Typography variant={'lora-title-large'} fontWeight={"bold"} color={'primary'}>Upload a profile photo</Typography>  
            <Typography variant={'body-medium'} color={'black.400'} paddingY={'8px'}>Add a profile photo so {userType === 'client' ? 'Talents' : 'Clients'} viewing your profile can get to know you more.</Typography>
            <Box display={"flex"} justifyContent={"center"} flexDirection={"column"} alignItems={'center'} width={"100%"} paddingY={'12px'} >
                <Box display={"flex"} flexDirection={"column"} alignItems={'center'} {...getRootProps()}>
                    <input {...getInputProps()} />
                    {
                        objectUrl  ? (<img src={objectUrl} style={{maxWidth: "142px", borderRadius: "50%", width: '120px', height: '120px'}}/>) : <KaziAvatar />
                    }
                </Box>
                <Box display={"flex"} flexDirection={"row"}>
                    <Button sx={{marginTop: "20px"}} onClick={open}>
                        <Add fontSize='small' sx={{marginRight: 0.5}}/>
                        <Typography variant={'label-large'} color={'primary'}>{isDragActive ? 'Drop file here...' : (objectUrl ? 'Change photo': 'Add photo')}</Typography>
                    </Button>
                </Box>
            </Box>
        </Grid>
    )
}